import { render, staticRenderFns } from "./mixFooter.vue?vue&type=template&id=5fa3e657"
import script from "./mixFooter.vue?vue&type=script&lang=js"
export * from "./mixFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports